import React, {useEffect, useState} from "react";
import RadioButton from "../../lib/form/RadioButton/RadioButton";
import {FilterState, initialFilterState, ShowFilter, SortFilter} from "../ShopRatingSection";
import {useTranslation} from "react-i18next";
import styles from "./RatingFilter.module.scss";
import Checkbox from "../../lib/form/Checkbox/Checkbox";

type RatingFilterProps = {
  filterState: FilterState;
  onChange: (filterState: FilterState) => void;
  onReset: () => void;
};

const RatingFilterMobile: React.FC<RatingFilterProps> = ({onChange, onReset, filterState}) => {
  const {t} = useTranslation();
  const [state, setState] = useState<FilterState>(initialFilterState);

  useEffect(() => {
    setState(filterState);
  }, [filterState]);

  return (
    <div className={styles.ratingWrapperMobile}>
      <div>
        <div>
          {t("Sortieren nach")}
          <div className={styles.radioGroup}>
            <div className={styles.radioWrapper}>
              <RadioButton
                name="sort"
                size={2}
                className={styles.radio}
                value={SortFilter.best}
                checked={state.sort === SortFilter.best}
                onChange={() => {
                  setState({...state, sort: SortFilter.best});
                }}
              >
                {t("Beste")}
              </RadioButton>
            </div>

            <div className={styles.radioWrapper}>
              <RadioButton
                name="sort"
                className={styles.radio}
                size={2}
                value={SortFilter.newest}
                checked={state.sort === SortFilter.newest}
                onChange={() => {
                  setState({...state, sort: SortFilter.newest});
                }}
              >
                {t("Neueste")}
              </RadioButton>
            </div>

            <div className={styles.radioWrapper}>
              <RadioButton
                name="sort"
                size={2}
                className={styles.radio}
                value={SortFilter.worst}
                checked={state.sort === SortFilter.worst}
                onChange={() => {
                  setState({...state, sort: SortFilter.worst});
                }}
              >
                {t("Schlechteste")}
              </RadioButton>
            </div>
          </div>
        </div>
        <div>
          {t("Filtern nach")}
          <div>
            {[5, 4, 3, 2, 1].map((index) => {
              return (
                <div className={styles.checkboxWrapper} key={`RatingFilterMobile${index}`}>
                  <Checkbox
                    checked={state.filterSet.has(index) || false}
                    onChange={(checked) => {
                      setState((prevState) => {
                        const updatedSet = prevState.filterSet;

                        if (checked) {
                          updatedSet.add(index);
                        } else {
                          updatedSet.delete(index);
                        }

                        return {...prevState, filterSet: updatedSet};
                      });
                    }}
                  >
                    <span className={styles.starsLabel}>{t("{{star}} Sterne", {star: index})}</span>
                  </Checkbox>
                </div>
              );
            })}
          </div>
        </div>
        <div>
          {t("Varianten")}
          <div className={styles.radioGroup}>
            <div className={styles.radioWrapper}>
              <RadioButton
                name="show"
                size={2}
                className={styles.radio}
                value={ShowFilter.all}
                checked={state.show === ShowFilter.all}
                onChange={() => {
                  setState({...state, show: ShowFilter.all});
                }}
              >
                {t("Alle Varianten")}
              </RadioButton>
            </div>
            <div className={styles.radioWrapper}>
              <RadioButton
                name="show"
                size={2}
                className={styles.radio}
                value={ShowFilter.one}
                checked={state.show === ShowFilter.one}
                onChange={() => {
                  setState({...state, show: ShowFilter.one});
                }}
              >
                {t("Ausgewählte Variante")}
              </RadioButton>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.buttonsWrapper}>
        <button
          className={`${styles.button} ${styles.submit}`}
          onClick={() => {
            onChange(state);
          }}
        >
          {t("Filter anwenden")}
        </button>
        <button
          className={`${styles.button}`}
          onClick={() => {
            onReset();
          }}
        >
          {t("Filter zurücksetzen")}
        </button>
      </div>
    </div>
  );
};

export default RatingFilterMobile;
